import React, {Component} from 'react'
import {Container, Row, Col} from 'react-bootstrap'
import Input from './btn_input'
import InputForm from './inputs'
import Select from './select'
import Groups from './group_select'
import './style.css'

export default class Akun extends Component {
    state = {
        profileImg: "asset/users/user.png"
    }

    imgHandler = e => {
        const reader = new FileReader()
        reader.onload = () => {
            if(reader.readyState === 2) {
                this.setState({profileImg: reader.result})
            }
        }
        reader.readAsDataURL(e.target.files[0])
    }

    render() {
        const { profileImg } = this.state
    return (
        <Container className="user-akun-page">
            <Row>
                <Col md={4}>
                    <div className="akun mt-4">
                        <img src={profileImg} alt="img-user" />
                        <Input type="file" id="input" onChange={this.imgHandler} />
                        <label htmlFor="input" className="image-upload">Pilih Foto</label>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est, consequuntur similique explicabo tempore pariatur exercitationem labore necessitatibus nobis fugiat fuga eligendi magnam excepturi praesentium quam vero perferendis! Dolores, ullam autem?</p>
                        <Input type="button" name="ubah-sandi" id="btn-sandi" value="Ubah Kata Sandi" />
                        <Input type="button" name="show-kode" id="btn-kode" value="Lihat Kode Referral" />
                    </div>
                </Col>
                <Col md={8}>
                    <form>
                        <InputForm text_form="Name" title="Ubah Informasi Akun" type="text" name="form-input" small="(Contoh : Umar Sabirin)" />
                        <InputForm text_form="No. Hp" type="tel" name="form-input" small="(Contoh : 0812-3456-7890)" />
                        <InputForm text_form="Tanggal Lahir" type="date" name="form-date" small="22/08/2000" />
                        <Select select="Jenis Kelamin" id="jenis_kelamin" option1="Laki - Laki" value1="Laki - Laki" option2="Permpuan" value2="Perempuan" small="Pilih Jenis Kelamin" />
                        <Select select="Pekerjaan" id="Pekerjaan" option1="Freelance" value1="Freelance" option2="Wirausaha" value2="Wirausaha" small="Pilih Pekerjaan anda saat ini" />
                        <InputForm text_form="Email" type="email" name="form-email" small="(Contoh : user@malmora.com)" /> 
                        <Groups />
                        <div style={{marginTop:"18px"}}>
                            <InputForm text_form="Tentang" type="text" name="form-tentang" small="(Contoh : Selamat Datang !)" />
                        </div>
                        <Input type="button" name="btn-simpan" id="btn-simpan" value="Simpan" />
                   </form>
                </Col>
            </Row>
        </Container>
    )
    }
}

